import api from './api';
import { toast } from 'react-toastify';

export const sendForApproval = async (requestId, requesterId) => {
    try {
        const response = await api.put(`/api/overtime/sendForApproval/${requestId}/${requesterId}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const getFormattedRequest = async (requestId) => {
    try {
        const response = await api.get(`/api/overtime/getFormattedRequest/${requestId}`);
        return response.data;
    } catch (error) {
        return [];
    }
};

export const getActiveUsers = async () => {
    try {
        const response = await api.get(`/api/users/getActiveUsers`);
        return response.data;
    } catch (error) {
        return [];
    }
};

export const fetchQtyOfItemsByRequest = async (id) => {
    try {
        const response = await api.get(`/api/overtime/getQtyOfItemsByRequest/${id}`);
        const data = response.data;
        return data.result ? (data.qty === 0 ? true : false) : true;
    } catch (error) {
        toast.error('Lo sentimos, algo salió mal.');
        return true;
    }
};

export const fetchDatesBetween = async () => {
    try {
        const response = await api.get(`/api/generalQueries/getWednesdays`);
        return response.data;
    } catch (error) {
        toast.error('Lo sentimos, algo salió mal.');
        return {
            "previousWednesday": null,
            "previousWednesdayFormatted": null,
            "nextWednesday": null,
            "nextWednesdayFormatted": null,
            "currentDate": null,
            "currentDateFormatted": null,
        };
    }
};

export const fetchRequestById = async (id) => {
    try {
        const response = await api.get(`/api/overtime/getRequestById/${id}`);
        return response.data;
    } catch (error) {
        return null;
    }
};

export const returnToDraft = async (requestId, userId) => {
    try {
        const response = await api.put(`/api/overtime/returnToDraft/${requestId}/${userId}`);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const insertItem = async (existId, requestId, formData) => {
    const url = existId ? "/api/overtime/insertItem" : "/api/overtime/insertFirstItem";
    try {
        const response = await api.post(url, formData);
        return response.data;
    } catch (error) {
        return { result: false, requestId };
    }
};

export const getGroupedDates = async () => {
    try {
        const response = await api.get(`/api/overtime/getGroupedDates`);
        return response.data;
    } catch (error) {
        return [];
    }
};
